<template>
  <b-card @click="$emit('click')">
    <b-img-lazy center :src="template.icon.url"></b-img-lazy>
    <b-card-body class="text-center">
      <b-card-title class="font-weight-bold">{{ template.label }}</b-card-title>

      <b-card-text class="text-secondary">
        {{ template.description }}
      </b-card-text>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    template: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.card {
  @media (max-width: 767px) {
    img {
      width: 74px;
      height: 74px;
    }

    .card-body {
      padding-top: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      padding-bottom: 0.5rem;
    }

    .card-title {
      font-size: 1rem;
    }

    .card-text:last-child {
      font-size: 0.9rem;
      line-height: 15px;
    }
  }
}
</style>
